import { Formik } from "formik";
import styles from "./addStaff.module.scss";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { MANAGE_PARENT, MANAGE_STAFF } from "config/paths";
import { CommonMultiSelect, CommonSelect, CstmPagination, RequiredFieldAstrick } from "components/Common/Common";
import AppInputField from "components/shared/FormComponents/AppInputField";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { CLIENT_TYPES, DAY_OPTIONS, PARENT_CLIENT_TYPES, STAFF_DURATION_OPTIONS, STAFF_ENDS_ON_OPTIONS, STAFF_ENDS_TRACKER_OPTIONS, STAFF_TASK_TYPE_OPTIONS } from "config/constants";
import { useCallback, useEffect, useState } from "react";
import moment from "moment";
import addStaffSchema from "./addStaff.schema";
import { cloneDeep, debounce, isEmpty } from "lodash";
import { errorMessageToast, successMessageToast, userFullName } from "helpers/common";
import TableLayout from "components/TableLayout";
import LoadingOverlay from "components/shared/LoadingOverlay";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { useCreateStaffMutation, useLazyGetGuardiansListQuery, useLazyGetStaffListTaskTemplatesQuery } from "store/services/staff";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { genericFormErrorMsg } from "utils/validation/validationHelpers";
import { useLazyGetClientsListLookupQuery } from "store/services/clients/apprentice";

const AddParentTask = () => {

	const navigate = useNavigate();

	const initialValues = {
		task_title: "",
		task_datetime: "",
		time: "",
		duration: "",
		custom_duration: {
			every: "",
			durationType: "",
			frequency: ""
		},
		ends_on: "",
		ends_on_data: {
			endDate: "",
			occurence: ""
		},
		description: "",
		tracker_type: "",
		task_type: "single",
		group_name: "",
		staff_id: "",
		clientType: "",
		task_for: "parent"
	};

	// clients list
	const [clientListFilter, setClientListFilter] = useState({ type: "", data: { status: "active", serach: "", page: 1, limit: 10, sort:{"column":"firstname","direction":"ASC"} } });
	const [getClients, { isLoading: getClientsLoading, isFetching: getClientsFetching }] = useLazyGetClientsListLookupQuery();
	const [clientsList, setClientsList] = useState([]);
	const [titleOptions, setTitleOptions] = useState([])

	// Guardians List
	const [getGuardians, { isLoading: getGuardiansLoading, isFetching: getGuardiansFetching }] = useLazyGetGuardiansListQuery();
	const [guardiansList, setGuardiansList] = useState([]);

	const [selectedClients, setSelectedClients] = useState([]);

	const [createTask, { isLoading: createTaskLoading }] = useCreateStaffMutation();

	const [getPopulatedList, { data: populatedData, isFetching: populatedDataLoading }] = useLazyGetStaffListTaskTemplatesQuery();


	const getClientOptions = async () => {
		try {

			const response = await getClients(clientListFilter);
			if (!response.error) setClientsList(response?.data?.data?.records?.map(i => ({ label: userFullName(i), value: i.id })) || [])

		} catch (error) { console.log("error getting staff list", error); };
	};

	const getGuardiansList = async (id) => {
		try {
			const result = await getGuardians(id);
			if (result?.data) {
				setGuardiansList(result?.data?.client_detail?.client_guardian_mapping?.map(i => i?.client_guardian))
				return;
			};

			setGuardiansList([]);
		} catch (error) { console.log("error getting parents list", error); };
	};
	console.log('selectedClients', selectedClients)
	const handleSearchChange = useCallback(debounce((search) => {
		setClientListFilter(x => ({ ...x, data: { ...x.data, search } }));
	}, 500), []);

	const customDurationOptions = [
		{
			label: "Day",
			value: "day"
		},
		{
			label: "Week",
			value: "week"
		},
		{
			label: "Month",
			value: "month"
		}
	];

	const [customDurationMonthOptions, setCustomDurationMonthOptions] = useState([
		{
			label: `Monthly on day ${moment().get('date')}`,
			value: moment().get('date')
		},
		{
			label: `Monthly on the ${moment().format('dddd')}`,
			value: moment().format('dddd')
		}
	]);

	const handleSubmit = async (values) => {
		if (!selectedClients) {
			return errorMessageToast("Please select client");
		}

		const payload = cloneDeep(values);
		// Format values
		// payload.task_datetime = values?.task_datetime + " " + values.time + ":00"
		payload.task_datetime = values?.task_datetime + " " + "00:01:00"
		payload.tracker_type = values?.tracker_type?.value;
		payload.staff_id = values?.staff_id?.value;
		payload.ends_on = values?.ends_on?.value || "";
		payload.duration = values?.duration?.value;
		payload.clients = [selectedClients];
		payload.custom_duration = {
			...payload.custom_duration,
			durationType: payload?.custom_duration?.durationType?.value || "",
			frequency: payload?.custom_duration?.frequency ? (payload?.custom_duration?.frequency?.value || payload?.custom_duration?.frequency?.map(i => i.value)) : ""
		};

		if (payload.duration == "no_repeat") {
			payload.ends_on = "on_date";
			payload.ends_on_data.endDate = payload.task_datetime?.split(" ")?.[0] || ""
		};

		delete payload.clientType;
		delete payload.time;

		const result = await createTask(payload);
		if (!result.error) {
			successMessageToast(result?.data?.message);
			navigate(MANAGE_PARENT)
		};
	};

	const column = [
		{
			head: "Last Name",
			accessor: "lastname",
			isComponent: true,
			component: (item, ind) => (
				<div className="d-flex gap-2 align-items-center">
					<input
						type="checkbox"
						onChange={() => handleSelectClient(item?.id)}
						checked={selectedClients === item?.id}
					/>
					<h6 className="m-0 fw-sbold">{item?.lastname || ""}</h6>
				</div>
			),
		},
		{
			head: "First Name",
			accessor: "firstname",
			isComponent: true,
			component: (item, ind) => (
				<div className="d-flex gap-2 align-items-center">
					<h6 className="m-0 fw-sbold">{item?.firstname || ""}</h6>
				</div>
			),
		},
	];

	// const handleSelectClient = (id) => {

	// 	let list = cloneDeep(selectedClients);
	// 	const index = list.indexOf(id);

	// 	if (index > -1) delete list[index]
	// 	else list.push(id);
	// 	list = list.filter(Boolean);

	// 	setSelectedClients(list);
	// };

	const handleSelectClient = (id) => {
		setSelectedClients(id);
	}

	const getPopulatedData = async (search) => {
		const filter = { page: 1, limit: 50, search }
		try {
			const result = await getPopulatedList({ ...filter }).unwrap();
			if (result?.records?.length) {
				const titleList = result.records.map(item => ({
					value: item.id,
					label: item.task_title // or whatever field contains the title
				}));
				setTitleOptions(titleList);
			} else {
				setTitleOptions([]);
			}
		} catch (err) {
			console.error("error fetching titles", err);
			setTitleOptions([]);
		}
	};

	const handleSearch = useCallback(debounce((search = "", access) => {
		console.log("SEARCH LIST ", search)
		if (search || access) getPopulatedData(search);
		// else {
		// 	setTitleOptions([]);
		// }
	}, 500), []);

	// get clients list on type change
	useEffect(() => {

		if (clientListFilter?.type) getClientOptions();
	}, [clientListFilter]);

	useEffect(() => {
		handleSearch("", true)
	}, [])
	
	return (
		<section
			className={`${styles.addStaff} position-relative py-4 addManage`}
		>
			<Container fluid>
				<Row>
					<div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
						<div className="left">
							<ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
								<li className="">
									<h6 className="m-0 fw-bold themeBlue">{"Add New Task"}</h6>
								</li>
							</ul>
						</div>
					</div>
					<Col lg="12" className="my-2">
						<Formik
							initialValues={initialValues}
							validationSchema={addStaffSchema}
							onSubmit={handleSubmit}
							enableReinitialize
						>
							{
								({
									handleSubmit,
									values,
									setFieldValue,
									errors,
									submitCount,
									setValues
								}) => (
									<Form onSubmit={handleSubmit}>
										<div
											className="py-3"
											style={{ borderTop: "1px solid #41a2a84d" }}
										>
											<Row>
												<Col md="4" sm="6" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0 d-flex"
													>
														Title
														<RequiredFieldAstrick />
													</label>
													{/* <GuardianPicker
																						  type="parents"
																						  name={`parentLastname`}
																						  placeholder={"Search Last Name"}
																						/> */}
													<CommonSelect
														// isDisabled={editMode}
														placeholder={"Search Title"}
														isClearable
														name="task_title"
														// handleBlur={() => setParentOptions([])}
														creatable={true}
														onInputChange={(e) => handleSearch(e)}
														option={titleOptions}
														onClick={() => handleSearch("", true)}
														isLoading={populatedDataLoading}
														// value={values?.parentLastname && { label: values?.parentLastname, value: values?.parentLastname }}
														// onChange={(selected) => {
														// 	let guardian = parentOptions?.find(guardian => guardian.id === selected?.value);
														// 	let selectedValue = {
														// 		...selected,
														// 		label: guardian?.lastname
														// 	};
														// 	if (!guardian) {
														// 		setClientOptions([])
														// 		setFieldValue(`parentLastname`, selected);
														// 		setFieldValue(`parentId`, null);
														// 		setFieldValue(`parentFirstname`, "");
														// 		setFieldValue(`parentEmail`, "");
														// 		setFieldValue(`parentPhone`, "");
														// 		setFieldValue('clientType', "")
														// 		setFieldValue('clientId', "")
														// 		setConsentFormOptions([]);
														// 		setFieldValue("consentForms", []);

														// 		return;
														// 	}
														// 	setFieldValue(`parentLastname`, guardian.lastname);
														// 	setFieldValue(`parentId`, selectedValue.id);
														// 	setFieldValue(`parentFirstname`, guardian?.firstname);
														// 	setFieldValue(`parentEmail`, guardian?.email);
														// 	setFieldValue(`parentPhone`, guardian?.phone);
														// 	setFieldValue('clientType', "")
														// 	setFieldValue('clientId', "")
														// 	setParentOptions([])
														// 	setConsentFormOptions([]);
														// 	setFieldValue("consentForms", []);
														// }}
														value={titleOptions.find(option => option.value === values.task_title?.value)}
														onChange={(selected) => {
															if (selected) {
																const selectedTask = populatedData?.records?.find((task) => task.id === selected.value);
																console.log("SELECTED TASK ", selectedTask)
																setFieldValue("task_title", selected?.label);
																setFieldValue("description", selectedTask?.description || "");
															} else {
																// Clear fields if selection is cleared
																setFieldValue("task_title", "");
																setFieldValue("description", "");
															}
														}}
													/>
												</Col>
												{/* <Col md="4" sm="6" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0"
													>
														Title
														<RequiredFieldAstrick />
													</label>
													<AppInputField
														name="task_title"
														type="text"
														placeholder="Enter Title"
														className={`${styles.formControl} form-control`}
														maxLength={100}
													/>
												</Col> */}
												<Col md="4" sm="6" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0"
													>
														Date
														<RequiredFieldAstrick />
													</label>
													<AppDatePicker
														portalId={"root"}
														name="task_datetime"
														className={`${styles.formControl} form-control`}
														handleChangeValue={(date) => {
															setCustomDurationMonthOptions([
																{
																	label: `Monthly on day ${moment(date, "YYYY-MM-DD").get('date')}`,
																	value: moment(date, "YYYY-MM-DD").get('date')
																},
																{
																	label: `Monthly on the ${moment(date, "YYYY-MM-DD").format('dddd')}`,
																	value: moment(date, "YYYY-MM-DD").format('dddd')
																}
															])
														}}
													/>
												</Col>
												{/* <Col md="4" sm="6" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0"
													>
														Time
														<RequiredFieldAstrick />
													</label>
													<AppInputField
														name="time"
														type="time"
														placeholder=""
														className={`${styles.formControl} form-control`}
														maxLength={100}
													/>
												</Col> */}
												<Col md="4" sm="6" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0"
													>
														Duration
														<RequiredFieldAstrick />
													</label>
													<CommonSelect
														name="duration"
														placeholder={"Select Duration"}
														option={STAFF_DURATION_OPTIONS}
														onChange={(val) => {
															setValues({
																...values,
																duration: val,
																custom_duration: { every: "", durationType: "", frequency: "" },
																ends_on: "",
																ends_on_data: { endDate: "", occurence: "" }
															});
														}}
													/>
												</Col>
												{
													values?.duration?.value == "custom" && <Col md="4" sm="6" className="my-2">
														<label
															htmlFor=""
															className="form-label themeBlue fw-bold mb-0"
														>
															Repeat Every
															<RequiredFieldAstrick />
														</label>
														<AppInputField
															name="custom_duration.every"
															type="number"
															placeholder="Enter Frequency"
															className={`${styles.formControl} form-control`}
															maxLength={100}
															min={1}
															onKeyDown={e => (e.key == "-" || e.key == "e" || e.key == "E") && e.preventDefault()}
														/>
													</Col>
												}
												{
													values?.duration?.value == "custom" && <Col md="4" sm="6" className="my-2">
														<label
															htmlFor=""
															className="form-label themeBlue fw-bold mb-0"
														>
															Duration Type
															<RequiredFieldAstrick />
														</label>
														<CommonSelect
															name="custom_duration.durationType"
															placeholder={"Select Duration Type"}
															option={customDurationOptions}
															onChange={(val) => {
																setFieldValue("custom_duration", { ...values.custom_duration, durationType: val, frequency: "" })
															}}
														/>
													</Col>
												}
												{
													values?.custom_duration?.durationType?.value == "week" && <Col md="4" sm="6" className="my-2">
														<label
															htmlFor=""
															className="form-label themeBlue fw-bold mb-0"
														>
															Day's
															<RequiredFieldAstrick />
														</label>
														<CommonMultiSelect
															name="custom_duration.frequency"
															placeholder={"Select Day's"}
															option={DAY_OPTIONS}
														/>
													</Col>
												}
												{
													values?.custom_duration?.durationType?.value == "month" && <Col md="4" sm="6" className="my-2">
														<label
															htmlFor=""
															className="form-label themeBlue fw-bold mb-0"
														>
															Month Day
															<RequiredFieldAstrick />
														</label>
														<CommonSelect
															name="custom_duration.frequency"
															placeholder={"Select Month Day"}
															option={customDurationMonthOptions}
														/>
													</Col>
												}

												{values?.duration?.value == "custom" && <Col md="4" sm="6" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0"
													>
														End's On
														<RequiredFieldAstrick />
													</label>
													<CommonSelect
														name="ends_on"
														placeholder={"Select End's on"}
														option={STAFF_ENDS_ON_OPTIONS}
														onChange={(val) => {
															setValues({
																...values,
																ends_on: val,
																ends_on_data: { endDate: "", occurence: "" }
															});
														}}
													/>
												</Col>}
												{values?.ends_on?.value == "on_date" && <Col md="4" sm="6" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0"
													>
														End Date
														<RequiredFieldAstrick />
													</label>
													<AppDatePicker
														portalId={"root"}
														name="ends_on_data.endDate"
														className={`${styles.formControl} form-control`}
													/>
												</Col>}
												{values?.ends_on?.value == "after" && <Col md="4" sm="6" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0"
													>
														Occurance
														<RequiredFieldAstrick />
													</label>
													<AppInputField
														name="ends_on_data.occurence"
														type="number"
														placeholder=""
														className={`${styles.formControl} form-control`}
														maxLength={100}
														min={1}
														onKeyDown={e => (e.key == "-" || e.key == "e" || e.key == "E") && e.preventDefault()}
													/>
												</Col>}
												<Col md="12" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0"
													>
														Clinician's Instructions
													</label>
													<RequiredFieldAstrick />
													<AppInputField
														name="description"
														fieldType="textarea"
														placeholder=""
														className={`${styles.formControl} ${styles.textarea} form-control`}
														rows={5}
														maxLength={500}
													/>
												</Col>
												<Col md="4" sm="6" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0"
													>
														Tracker Type
														<RequiredFieldAstrick />
													</label>
													<CommonSelect
														name="tracker_type"
														placeholder={"Select Group Type"}
														option={STAFF_ENDS_TRACKER_OPTIONS}
													/>
												</Col>
												<Col md="4" sm="6" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0"
													>
														Client Type
														<RequiredFieldAstrick />
													</label>
													<CommonSelect
														name="clientType"
														placeholder={"Select Client Type"}
														option={PARENT_CLIENT_TYPES}
														onChange={(e) => {
															setClientListFilter(x => ({ ...x, type: e?.value }))
															setFieldValue("staff_id", "")
														}}
													/>
												</Col>
												<Col md="4" sm="6" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0"
													>
														Client
														<RequiredFieldAstrick />
													</label>
													<CommonSelect
														name="staff_id"
														isClearable={true}
														placeholder={"Select Client"}
														option={clientsList}
														isLoading={getClientsLoading || getClientsFetching}
														onInputChange={(e) => handleSearchChange(e)}
														onChange={(e) => { getGuardiansList(e?.value); setSelectedClients(null) }}
													/>
												</Col>
											</Row>
										</div>
										<Row className="border-top">
											<Col lg="12" sm="12" className="my-4 " >
												{/* {console.log("guardiansList", guardiansList)} */}
												<TableHeader
													heading={"Guardians List"}
													hideFilters
												/>
											</Col>
											<div className="table-outer" style={{ maxHeight: "40vh" }}>
												{getGuardiansLoading || getGuardiansFetching ? <LoadingIndicator /> : <TableLayout
													data={guardiansList}
													column={column}
												/>}
											</div>
										</Row>
										<Row className="mt-5 ">
											{(!isEmpty(errors) && submitCount > 0) && (
												<Row className="my-2">
													<Col lg="12">
														<span className="error">{genericFormErrorMsg}</span>
													</Col>
												</Row>
											)}
											<Col className="my-2" lg="12">
												<div
													className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
													style={{ borderTop: "1px solid #41a2a84d" }}
												>
													<Button
														className="d-flex align-items-center justify-content-center commonBtn"
														type="submit"
														disabled={createTaskLoading}
													>
														{createTaskLoading ? <LoadingIndicator /> : "Save"}
													</Button>
													<Button
														className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
														type="button"
														onClick={() => navigate(MANAGE_PARENT)}
													>
														Cancel
													</Button>
												</div>
											</Col>
										</Row>
									</Form>
								)}

						</Formik>
					</Col>
				</Row>
			</Container>
		</section>
	)
};

export default AddParentTask;